<ng-container *ngIf="crcat$ | async as crcat">
	<ng-container *ngIf="formGroup">
		<form [formGroup]="formGroup" class="cm-form" (ngSubmit)="handleSubmit()">
			<cm-localize
				class="cm-form__field-group cm-form__field-group--full-width creq-upload-instructions pb-0"
				[name]="locs.SPUploadFormContentInstructions"
				[cpName]="locs.CPUploadFormContentInstructions" />
			@if (crcat.instructions) {
			<div
				class="cm-form__field-group cm-form__field-group--full-width creq-upload-instructions pb-0"
				[innerHTML]="crcat.instructions"></div>
			}

			<mat-form-field>
				<mat-label>
					<cm-localize
						[name]="locs.SPUploadConfirmationFieldLabelActiveDate"
						[cpName]="locs.CPUploadConfirmationFieldLabelActiveDate" />
				</mat-label>
				<input
					matInput
					formControlName="activeDate"
					[min]="minDate"
					placeholder="yyyy-mm-dd"
					[matDatepicker]="activeDatePicker"
					[max]="today"
					required />
				<mat-error *ngIf="activeDate.invalid && (activeDate.dirty || activeDate.touched)">
					<div *ngIf="activeDate.errors.required">
						<cm-localize
							[name]="locs.SPUploadFormFieldErrorActiveDateRequired"
							[cpName]="locs.CPUploadFormFieldErrorActiveDateRequired" />
					</div>
					<div
						*ngIf="
							activeDate.errors.matDatepickerMin || activeDate.errors.matDatepickerMax
						">
						<cm-localize
							[name]="locs.SPUploadFormFieldErrorActiveDateInvalid"
							[cpName]="locs.CPUploadFormFieldErrorActiveDateInvalid" />
					</div>
				</mat-error>
				<mat-datepicker-toggle matSuffix [for]="activeDatePicker">
					<ats-icon name="calendar" matDatepickerToggleIcon></ats-icon>
				</mat-datepicker-toggle>
				<mat-datepicker #activeDatePicker></mat-datepicker>
			</mat-form-field>

			<ng-container *ngIf="isSP">
				<div class="cm-form__field-group cm-form__field-group--checkbox">
					<mat-checkbox formControlName="overrideExpireDate">
						<cm-localize [name]="locs.SPUploadFormFieldLabelOverrideExpireDate" />
					</mat-checkbox>
				</div>

				<mat-form-field *ngIf="overrideExpiration$ | async">
					<mat-label>
						<cm-localize
							[name]="locs.SPUploadConfirmationFieldLabelExpireDate"
							[cpName]="locs.CPUploadConfirmationFieldLabelExpireDate" />
					</mat-label>
					<input
						matInput
						formControlName="expireDate"
						[min]="today"
						placeholder="yyyy-mm-dd"
						[matDatepicker]="expireDatePicker" />
					<mat-error
						*ngIf="expireDate.invalid && (expireDate.dirty || expireDate.touched)">
						<cm-localize
							*ngIf="
								expireDate.errors.matDatepickerMin ||
								expireDate.errors.matDatepickerMax
							"
							[name]="locs.SPUploadFormFieldErrorExpireDateInvalid"
							[cpName]="locs.CPUploadFormFieldErrorExpireDateInvalid" />
					</mat-error>
					<mat-datepicker-toggle matSuffix [for]="expireDatePicker">
						<ats-icon name="calendar" matDatepickerToggleIcon></ats-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #expireDatePicker></mat-datepicker>
				</mat-form-field>
			</ng-container>

			<mat-form-field *ngIf="crcat.providerRequired !== null">
				<mat-label>
					<cm-localize
						[name]="locs.SPUploadConfirmationFieldLabelProvider"
						[cpName]="locs.CPUploadConfirmationFieldLabelProvider" />
				</mat-label>
				<input matInput formControlName="provider" [required]="!!crcat.providerRequired" />
				<mat-error *ngIf="provider.invalid && (provider.dirty || provider.touched)">
					<cm-localize
						*ngIf="provider.errors.required"
						[name]="locs.SPUploadFormFieldErrorProviderRequired"
						[cpName]="locs.CPUploadFormFieldErrorProviderRequired" />
				</mat-error>
			</mat-form-field>

			<ng-container *ngIf="crcat.docRequired !== null">
				<cm-autocomplete [options$]="cultures$" formControlName="documentationLang">
					<cm-localize
						[name]="locs.SPUploadConfirmationFieldLabelDocLanguage"
						[cpName]="locs.CPUploadConfirmationFieldLabelDocLanguage" />
				</cm-autocomplete>

				<cm-file-upload
					formControlName="documentation"
					[multiple]="true"
					class="cm-form__field-group--full-width">
					<cm-localize
						[name]="locs.SPUploadConfirmationFieldLabelDocumentation"
						[cpName]="locs.CPUploadConfirmationFieldLabelDocumentation" />
					<div file-upload-hints>
						<cm-localize
							[name]="locs.SPUploadFormFieldErrorDocumentationSizeHint"
							[cpName]="locs.CPUploadFormFieldErrorDocumentationSizeHint" />
					</div>
					<div file-upload-errors>
						<div *ngIf="documentation.errors?.required">
							<cm-localize
								[name]="locs.SPUploadFormFieldErrorDocumentationRequired"
								[cpName]="locs.CPUploadFormFieldErrorDocumentationRequired" />
						</div>
						<div *ngIf="documentation.errors?.fileSize">
							<cm-localize
								[name]="locs.SPUploadFormFieldErrorDocumentationSize"
								[cpName]="locs.CPUploadFormFieldErrorDocumentationSize" />
						</div>
						<div *ngIf="documentation.errors?.maxlength">
							<cm-localize
								[name]="locs.SPUploadFormFieldErrorDocumentationLimit"
								[cpName]="locs.CPUploadFormFieldErrorDocumentationLimit" />
							>
						</div>
					</div>
				</cm-file-upload>
			</ng-container>

			<mat-form-field *ngIf="crcat.type === crcatType.CeActivity">
				<mat-label>
					<span *ngIf="crcat?.factorUnits">{{ crcat.factorUnits }}</span>
					<ng-container *ngIf="!crcat.factorUnits">
						<cm-localize
							[name]="locs.SPUploadConfirmationFieldLabelFactorNotFound"
							[cpName]="locs.CPUploadConfirmationFieldLabelFactorNotFound" />
					</ng-container>
				</mat-label>
				<input matInput formControlName="points" />
				<mat-hint>
					<div class="column-container">
						@if (crcat.points !== crcat.pointsMax) { @if (crcat.pointsMax > 0) {
						<div>
							<cm-localize
								[name]="locs.SPCrcatPointsMax"
								[cpName]="locs.CPCrcatPointsMax"></cm-localize>

							{{ crcat.pointsMax }}
						</div>
						} @if (crcat.points > 0) {
						<div>
							<cm-localize
								[name]="locs.SPCrcatPointsMin"
								[cpName]="locs.CPCrcatPointsMin"></cm-localize>

							{{ crcat.points }}
						</div>
						} }
					</div>
				</mat-hint>
				<mat-error *ngIf="points.invalid && (points.dirty || points.touched)">
					<div class="column-container">
						<div *ngIf="points.errors?.required">
							@if (crcat?.factorUnits) {
							{{ crcat.factorUnits }}&nbsp;<cm-localize
								[name]="locs.SPUploadFormFieldErrorPointsRequired"
								[cpName]="locs.CPUploadFormFieldErrorPointsRequired" />
							} @else {
							<cm-localize
								[name]="locs.SPUploadConfirmationFieldLabelFactorNotFound"
								[cpName]="
									locs.CPUploadConfirmationFieldLabelFactorNotFound
								" />&nbsp;<cm-localize
								[name]="locs.SPUploadFormFieldErrorPointsRequired"
								[cpName]="locs.CPUploadFormFieldErrorPointsRequired" />
							}
						</div>
						<div *ngIf="points.errors?.numeric">
							@if (crcat?.factorUnits) {
							{{ crcat.factorUnits }}&nbsp;<cm-localize
								[name]="locs.SPUploadFormFieldErrorPointsNumeric"
								[cpName]="locs.CPUploadFormFieldErrorPointsNumeric" />
							} @else {
							<cm-localize
								[name]="locs.SPUploadConfirmationFieldLabelFactorNotFound"
								[cpName]="
									locs.CPUploadConfirmationFieldLabelFactorNotFound
								" />&nbsp;<cm-localize
								[name]="locs.SPUploadFormFieldErrorPointsNumeric"
								[cpName]="locs.CPUploadFormFieldErrorPointsNumeric" />
							}
						</div>
						<div *ngIf="points.errors?.max">
							@if (crcat.pointsMax > 0) {
							<span>
								<cm-localize
									[name]="locs.SPCrcatPointsMax"
									[cpName]="locs.CPCrcatPointsMax"></cm-localize
								>&nbsp;{{ points.errors?.max?.max }}
							</span>
							}
						</div>
						<div *ngIf="points.errors?.min">
							@if (crcat.points > 0) {
							<span>
								<cm-localize
									[name]="locs.SPCrcatPointsMin"
									[cpName]="locs.CPCrcatPointsMin"></cm-localize
								>&nbsp;{{ points.errors?.min?.min }}
							</span>
							}
						</div>
						<div *ngIf="points.errors?.moduloMismatch">
							<cm-localize
								[name]="locs.SPUploadFormFieldErrorPointsFactor"
								[cpName]="locs.CPUploadFormFieldErrorPointsFactor" />&nbsp;<span
								>{{ points.errors?.moduloMismatch?.divisor }}
							</span>
						</div>
					</div>
				</mat-error>
			</mat-form-field>

			<mat-form-field class="cm-form__field-group--full-width">
				<mat-label>
					<cm-localize
						[name]="locs.SPUploadConfirmationFieldLabelDocNotes"
						[cpName]="locs.CPUploadConfirmationFieldLabelDocNotes" />
				</mat-label>
				<textarea matInput cdkTextareaAutosize formControlName="notes"></textarea>
			</mat-form-field>

			<mat-form-field class="cm-form__field-group--full-width" *ngIf="isSP">
				<mat-label>
					<cm-localize [name]="locs.SPUploadFormFieldLabelComments" />
				</mat-label>
				<textarea matInput cdkTextareaAutosize formControlName="comments"></textarea>
				<mat-hint>
					<cm-localize [name]="locs.SPUploadFormFieldHintComments" />
				</mat-hint>
			</mat-form-field>

			<div class="cm-form__actions">
				<button mat-button matStepperPrevious type="reset">
					<cm-localize
						[name]="locs.SPUploadFormButtonStepTwoBack"
						[cpName]="locs.CPUploadFormButtonStepTwoBack" />
				</button>
				<button mat-raised-button color="primary" type="submit">
					<cm-localize
						[name]="locs.SPUploadFormButtonStepTwoNext"
						[cpName]="locs.CPUploadFormButtonStepTwoNext" />
				</button>
			</div>
		</form>
	</ng-container>
</ng-container>
